/* Mejoras limitadas a las tarjetas del catálogo; conserva los controles nativos. */
(() => {
  if (customElements.get('ep-catalog-product-card')) return;

  class EpCatalogProductCard extends HTMLElement {
    connectedCallback() {
      this.updateCard();
      this.observer = new MutationObserver(() => {
        if (this.pendingUpdate) return;
        this.pendingUpdate = true;
        queueMicrotask(() => {
          this.pendingUpdate = false;
          if (this.isConnected) this.updateCard();
        });
      });
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'class', 'aria-disabled']
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    setText(element, text) {
      if (element && element.textContent !== text) element.textContent = text;
    }

    createBasket() {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      svg.classList.add('ep-catalog-card__basket');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.6');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS(namespace, 'path');
      path.setAttribute('d', 'M3 3h2l3 12h10l3-9H6 M9 19h.01 M18 19h.01');
      svg.append(path);
      return svg;
    }

    updateCard() {
      const nativeCard = this.querySelector('.card-wrapper > .card');
      if (!nativeCard) return;
      const content = Array.from(nativeCard.children).find(element => element.classList.contains('card__content'));
      const information = content?.querySelector('.card-information');
      const heading = content?.querySelector('.card__information > .card__heading');
      const vendor = information?.querySelector('.caption-with-letter-spacing');
      if (heading && vendor) {
        const vendorLabel = vendor.previousElementSibling;
        if (vendorLabel?.classList.contains('visually-hidden')) {
          this.setText(vendorLabel, 'Marca');
          heading.before(vendorLabel);
        }
        vendor.classList.add('ep-catalog-card__vendor');
        heading.before(vendor);
      }
      const titleLink = heading?.querySelector('a');
      if (titleLink && !titleLink.querySelector('.ep-catalog-card__title-text')) {
        const textNodes = Array.from(titleLink.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        if (textNodes.length) {
          const titleText = document.createElement('span');
          titleText.className = 'ep-catalog-card__title-text';
          textNodes.forEach(node => titleText.append(node));
          titleLink.prepend(titleText);
        }
      }
      const availability = this.querySelector('[data-ep-availability]');
      if (information && availability && availability.parentElement !== information) information.append(availability);

      nativeCard.querySelectorAll('.card__badge .badge').forEach(badge => {
        const discount = Number(this.dataset.discount);
        const label = this.dataset.productAvailable === 'false'
          ? 'Agotado'
          : discount > 0 ? `−${discount}%` : 'Oferta';
        this.setText(badge, label);
      });

      if (information) {
        const price = information.querySelector('.price');
        if (price && !price.querySelector('.ep-catalog-card__price-tag')) {
          const namespace = 'http://www.w3.org/2000/svg';
          const tag = document.createElementNS(namespace, 'svg');
          tag.classList.add('ep-catalog-card__price-tag');
          tag.setAttribute('viewBox', '0 0 24 24');
          tag.setAttribute('fill', 'none');
          tag.setAttribute('stroke', 'currentColor');
          tag.setAttribute('stroke-width', '1.7');
          tag.setAttribute('stroke-linecap', 'round');
          tag.setAttribute('stroke-linejoin', 'round');
          tag.setAttribute('aria-hidden', 'true');
          tag.setAttribute('focusable', 'false');
          const outline = document.createElementNS(namespace, 'path');
          outline.setAttribute('d', 'M20 12 12 20 3 11V3h8Z');
          const hole = document.createElementNS(namespace, 'circle');
          hole.setAttribute('cx', '7');
          hole.setAttribute('cy', '7');
          hole.setAttribute('r', '1');
          tag.append(outline, hole);
          price.prepend(tag);
        }
        information.querySelectorAll('.visually-hidden').forEach(label => {
          const text = label.textContent.trim();
          if (text === this.dataset.regularLabel?.trim()) this.setText(label, 'Precio original');
          else if (text === this.dataset.saleLabel?.trim()) this.setText(label, 'Precio con descuento');
        });
        const vendor = information.querySelector('.caption-with-letter-spacing');
        if (vendor?.previousElementSibling?.classList.contains('visually-hidden')) {
          this.setText(vendor.previousElementSibling, 'Marca');
        }
        const rating = information.querySelector('.rating');
        if (rating && this.dataset.rating && this.dataset.ratingMax) {
          const label = `${this.dataset.rating} de ${this.dataset.ratingMax} estrellas`;
          if (rating.getAttribute('aria-label') !== label) rating.setAttribute('aria-label', label);
        }
        const ratingCount = information.querySelector('.rating-count .visually-hidden');
        if (ratingCount && this.dataset.ratingCount) this.setText(ratingCount, `${this.dataset.ratingCount} valoraciones`);
      }

      content?.querySelectorAll('.quick-add__submit').forEach(button => {
        const modalOpener = button.closest('modal-opener');
        const soldOutMessage = button.querySelector('.sold-out-message');
        this.setText(soldOutMessage, 'Agotado');
        if (modalOpener) {
          const label = 'Elegir opciones';
          const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (textNode && textNode.textContent.trim() !== label) textNode.textContent = `${label} `;
        } else if (!button.classList.contains('loading') && button.getAttribute('aria-busy') !== 'true') {
          const label = button.querySelector('span:not(.sold-out-message):not(.svg-wrapper):not(.icon-wrap):not(.loading__spinner)');
          const unavailable = this.dataset.available === 'false' || button.disabled || (soldOutMessage && !soldOutMessage.classList.contains('hidden'));
          this.setText(label, unavailable ? 'Agotado' : 'Añadir al carrito');
        }
        if (!button.querySelector('.ep-catalog-card__basket')) button.prepend(this.createBasket());
        const basket = button.querySelector('.ep-catalog-card__basket');
        const shouldHide = button.classList.contains('loading') || (!modalOpener && (button.disabled || this.dataset.available === 'false'));
        if (shouldHide && !basket.hasAttribute('hidden')) basket.setAttribute('hidden', '');
        else if (!shouldHide && basket.hasAttribute('hidden')) basket.removeAttribute('hidden');
      });

      content?.querySelectorAll('.quick-add-modal__toggle').forEach(button => {
        if (button.getAttribute('aria-label') !== 'Cerrar') button.setAttribute('aria-label', 'Cerrar');
      });
      const dialog = content?.querySelector('quick-add-modal [role="dialog"]');
      if (dialog) {
        const title = content.querySelector('.card__heading')?.textContent.trim();
        const label = title ? `Elegir opciones de ${title}` : 'Elegir opciones del producto';
        if (dialog.getAttribute('aria-label') !== label) dialog.setAttribute('aria-label', label);
      }
    }
  }

  customElements.define('ep-catalog-product-card', EpCatalogProductCard);
})();
